import React from 'react';
import {useModel} from '../../helpers/model/use_model.js';
import {GeoModel} from './geo-model.js';
import {useStateContext} from "../../helpers/state-context.js";

const countryStyle = {
    // fill: '#afb6bb',
    // stroke: 'rgba(255,255,255,0.5)',
    strokeWidth: '1px',
    // vectorEffect: 'non-scaling-stroke'
};

const divide = (array, isValid) => {
    return array.reduce(([pass, fail], elem) => {
        return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    }, [[], []]);
}

function Countries(props) {
    const [state] = useStateContext()
    const resultSet = useModel(GeoModel, (m) => (m.getDataCountries()), {});

    if (resultSet.status !== GeoModel.Status.SUCCESS) {
        return null;
    }

    const getHatchPattern = (id, color) => (
        <defs>
            <pattern id={`hatch-${id}`}
                     width={.03 / state.zoom} height={.03 / state.zoom}
                     viewBox={'0,0,1,1'}
                     patternUnits="userSpaceOnUse"
                     patternTransform="rotate(45)">
                <rect width='10' height='10' fill={color} opacity={.4}/>
                <line x1="0" y1="0" x2="0" y2="10" style={{"stroke": color, "strokeWidth": ".15"}}/>
            </pattern>
        </defs>
    )

    const model = resultSet.data;
    const data = props.data

    const countryPaths = model.getCountryPaths();
    const countryData = model.getCountryData();
    const result = [];


    // TODO: IF 2 countries next to eachother are active the borders overlap.
    // sort list by inactive country to active country, so it draws the stroke correctly
    const [active, inactive] = divide(countryPaths, (e) => data.some((country) => country.country === countryData.get(e.id).id2));

    // By request of Permits we show Kashmir, Jammu and Ladakh with dotted lines. To always display the
    // dotted lines at the top we put those 2 'shapes' at the end of the array
    const [disputed, undisputed] = divide(inactive, (e) => ['xAC', 'xJK'].includes(e.id));
    const countries = [...undisputed, ...active, ...disputed];

    for (const country of countries) {
        const node = countryData.get(country.id);

        let isHover = false;
        if (model.hover) {
            const dim = model.hover.dimension;
            const val = model.hover.value;
            if (node[dim] === val || node.id2 === val) {
                isHover = true;
            }
        }
        let onTouchEnd;
        let onClick;
        let onMouseEnter;
        let onMouseLeave;
        let activeStyle = {
            fill: '#eef0f0',
            stroke: '#cfcfcf'
        };
        let countryHatch;

        const foundData = data.find((country) => (country.country === node.id2));
        if(foundData){
            onTouchEnd = () => {props.onSelect(foundData);};
            onClick = () => {props.onSelect(foundData);};
            onMouseEnter = () => props.onMouseEnter(foundData);
            onMouseLeave = ()=> props.onMouseLeave()

            const color = foundData.color ? foundData.color : 'darkgrey';

            activeStyle = {
                stroke: color,
                fill: `url(#hatch-${node.id2})`,
                cursor: 'pointer'
            };
            countryHatch = getHatchPattern(node.id2, color)
        }
        
        // Display Kashmir, Jammu and Ladakh areas as inactive (grey)
        if(['xAC', 'xJK'].includes(node.id3)){
            activeStyle.stroke = '#cfcfcf';
            activeStyle.strokeWidth = (model.scale / state.zoom) * 2 + 'px';
            activeStyle.strokeDasharray = .01 / state.zoom;
            activeStyle.fill = '#eef0f0';
            countryHatch = getHatchPattern(node.id2, '#e74e4e')
        }

        // JV: when moving from one country directly into the next, the mouseEnter isn't picked up for the
        // new country, this is a double check to get the hover state set when the mouse is on top of the
        // country
        const onMouseMove = () => {
            if(! state.countryHover && onMouseEnter){
                onMouseEnter();
            }
        }

        // (svg-pan-zoom) - When pan exists rescale bubble text, size and stroke based on the zoom
        const panZoom = (state.pan) ? state.zoom : 1
        const style = {
            ...countryStyle,
            strokeWidth: model.scale / panZoom + 'px',
            ...activeStyle,
            opacity: model.hover ? (isHover ? 1 : 0.8) : 1
        };

        result.push(<g key={node.id3}>
            {countryHatch}
            <path d={country.path} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} 
                    onMouseMove={onMouseMove} onClick={onClick} onTouchEnd={onTouchEnd} style={style}/>
        </g>);

        // can be helpful to understand the bounding boxes of the countries
        // if(node.localBBox && model.hover && isHover){
        //     const bbox = node.localBBox;
        //     result.push(<rect x={Math.min(bbox[0].x, bbox[1].x)} 
        //         y={Math.min(bbox[0].y, bbox[1].y)}
        //         width={Math.abs(bbox[1].x-bbox[0].x)}
        //         height={Math.abs(bbox[1].y-bbox[0].y)} 
        //         key={'rect_' + node.id3} 
        //         style={{stroke: 'red', strokeWidth: '0.004px', fill: 'transparent'}}
        //         />);
        // }

    }

    return <g transform={model.transformation}>

        {result.map((item) => (item))}
    </g>;

}


Countries.defaultProps = {
    getCountryClass: (item) => ('')
};


export {Countries};
